import { Dialog } from "@mui/material";
import { useScale, usePlaySound } from "common/utils";
import { ParentCloseBtn, FadeTransition } from "common/elements";
import I18n from "features/parent/i18n";

interface ParentWarningModalProps {
  open: boolean;
  title: string;
  message: string;
  icon?: string;
  confirmLabel?: string;
  onClose: () => void;
}

export const ParentWarningModal = ({
  open,
  title,
  message,
  icon = "warning",
  confirmLabel,
  onClose,
}: ParentWarningModalProps) => {
  const play = usePlaySound();
  const { scale } = useScale();

  const handleClose = () => {
    play();
    onClose();
  };

  return (
    <Dialog
      fullScreen
      open={open}
      maxWidth={false}
      sx={{ zIndex: 99999 }}
      TransitionComponent={FadeTransition}
      PaperProps={{ style: { backgroundColor: "transparent" } }}
    >
      <div className="flex-col-center w-full h-full bg-textcolor-black/50">
        <div style={{ transform: `scale(${scale})` }}>
          <div className="flex-col-el w-[600px] border-solid border-gray2-30 border-[16px] rounded-[16px] bg-gray2-30">
            <div className="flex-col-el justify-start w-full h-full relative p-6 rounded-[8px] bg-white">
              <ParentCloseBtn close={handleClose} />
              <div className="flex-row-el items-center gap-2 mb-4 pb-3 border-b border-outline shrink-0">
                <span className="material-symbols-outlined !text-[54px] text-red-100">{icon}</span>
                <h2 className="text-[33px] text-textcolor-black whitespace-nowrap">{title}</h2>
              </div>
              <div className="flex-col-view items-start py-4">
                {message.split("\n").map((line, index) => (
                  <p key={index} className="text-body text-textcolor-black text-[24px] mb-2">
                    {line}
                  </p>
                ))}
              </div>

              <div className="flex-row-el flex-center mt-4">
                <button
                  onClick={handleClose}
                  className="flex-row-el items-center justify-center w-[160px] py-3 bg-ink text-white border-none rounded-[12px] text-[24px] cursor-pointer hover:opacity-90 transition-all"
                >
                  {confirmLabel ?? I18n.t("MSG_CONFIRM_BTN_BY_PARENT")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
